module.exports = __webpack_public_path__ + "media/cash.2a6386d9.wav";